import { render, staticRenderFns } from "./UndecidedDetail.vue?vue&type=template&id=d460e2ea&scoped=true&"
import script from "./UndecidedDetail.vue?vue&type=script&lang=js&"
export * from "./UndecidedDetail.vue?vue&type=script&lang=js&"
import style0 from "./UndecidedDetail.vue?vue&type=style&index=0&id=d460e2ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d460e2ea",
  null
  
)

export default component.exports